import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { MenuCollapseItemComponent } from '../../../../components/menu-collapse-item/menu-collapse-item.component';
import { NavigationItem } from '../../../../interfaces/navigationList.interface';
import { GetActiveChildPipe } from '../../../../pipes/getActiveChild.pipe';
import { PageContainerService } from '../../../../services/page-container.service';
import { DropdownModule } from 'primeng/dropdown';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { filter, tap } from 'rxjs';

@Component({
  selector: 'z-top-header-single-tab',
  standalone: true,
  imports: [
    CommonModule,
    DropdownModule,
    FormsModule,
    OverlayPanelModule,
    GetActiveChildPipe,
    MenuCollapseItemComponent,
  ],
  templateUrl: './top-header-single-tab.component.html',
  styleUrls: ['./top-header-single-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopHeaderSingleTabComponent {
  @ViewChild('op') overlayPanel!: any;
  navigationItem = input.required<NavigationItem>();

  activeChild!: NavigationItem;
  currentPath = signal<number[] | undefined>(undefined);

  navigationItem$ = this.pageContainerService.activeSectionRoute.pipe(
    tap(nav => {
      if (nav?.children?.length) {
        this.setActiveItem(nav);
      }
    }),
  );

  routerEvent$ = this.router.events.pipe(
    filter(event => event instanceof NavigationEnd),
    tap(() => {
      this.overlayPanel.hide();
    }),
  );

  constructor(
    readonly pageContainerService: PageContainerService,
    readonly router: Router,
  ) {}

  ngAfterViewInit() {
    this.currentPath.set(
      this.pageContainerService
        .getRoutePath()
        .find(x => x.url === this.router.url)?.routePath,
    );
  }

  setActiveItem(nav: NavigationItem | null) {
    if (!nav) {
      return;
    }
    const currentPath = this.pageContainerService
      .getRoutePath()
      .find(x => x.url === this.router.url)?.routePath;

    this.currentPath.set(currentPath);

    const index = nav.children.findIndex(
      y => y && currentPath && y.id === currentPath[1],
    );
    if (index !== -1) {
      this.activeChild = nav.children[index];
    } else {
      return;
    }
  }
}
